<template lang="pug">
#monitoramento-operacoes-cda-wa
    BaseHeader(
        titulo='Monitoramento Operação CDA-WA',
        voltarPara,
        icon='el-icon-circle-plus-outline'
    )

    .view-container-base-header
        section.monitoramento-operacao__dados-gerais(
            v-loading='buscandoOperacao'
        )
            .titulo_padrao
                | Dados gerais da operação monitorada

            .monitoramento-operacao__dados-gerais__body
                .row.mb-5
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Identificador
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.identificador ? operacao.identificador : '-' }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Descrição
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.descricao ? operacao.descricao : '-' }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Observação
                        .monitoramento-operacao__dados-gerais__body__value(
                            style='word-break: break-all'
                        )
                            | {{ operacao.observacao ? operacao.observacao : '-' }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Armazém
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.nomeArmazem ? operacao.nomeArmazem : '-' }} {{ operacao.documentoArmazem ? operacao.documentoArmazem : '' }}

                .row.mb-5
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Safra
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.safra ? operacao.safra : '-' }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Cultura
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.cultura ? operacao.cultura : '-' }}

                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Data do contrato
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.dataContrato ? operacao.dataContrato : '-' }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Data do vencimento
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.dataVencimento ? operacao.dataVencimento : '-' }}

                .row
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Volume
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.volumeContratadoFormatado ? operacao.volumeContratadoFormatado : '-' }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Valor
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.valorFormatado ? operacao.valorFormatado : '-' }}
        section.monitoramento-operacao__dados-gerais(
            v-loading='buscandoOperacao'
        )
            .titulo_padrao
                | Fornecedor
            .monitoramento-operacao__dados-gerais__body
                .row
                    .col-4
                        .monitoramento-operacao__dados-gerais__body__title
                            | Nome
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.fornecedorNome ? operacao.fornecedorNome : '-' }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Documento
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.fornecedorDocumento ? operacao.fornecedorDocumento : '-' }}
                    .col-2
                        .monitoramento-operacao__dados-gerais__body__title
                            | Restrições
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ operacao.totalRestricoesFormatadas }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            |
                        .monitoramento-operacao__dados-gerais__body__value
                            BaseButton.margin-top(
                                icon='el-icon-view',
                                @click='visualizarAnalisePessoa',
                                size='big',
                                type='primary',
                                :disabled='buscandoDiagnosticos'
                            )
                                | Visualizar análise do Fornecedor

        section.monitoramento-operacao__restricoes(v-loading='buscandoCars')
            .monitoramento-operacao__restricoes__icone
                i.mdi.mdi-bell.monitoramento-operacao__restricoes__icone__icone

            .monitoramento-operacao__restricoes__texto
                | {{ getTotalRestricoes(totalRestricoes) }}

        section.monitoramento-operacao__listagem-imoveis
            .titulo_padrao
                | Listagem de imóveis monitorados

            .row.m-0
                .col-7.px-0.tabela
                    el-table(
                        :data='cars',
                        stripe,
                        height='calc(100% - 54px)',
                        @expand-change='highlightImovelEnter'
                    )
                        el-table-column(type='expand')
                            template(slot-scope='props')
                                .box-expande-listagem
                                    .box-expande-listagem-box
                                        .box-expande-listagem-box-texto
                                            | Produtor
                                        .box-expande-listagem-box-value(
                                            v-if='props.row.nomeProdutor'
                                        )
                                            div {{ props.row.nomeProdutor }} ({{ formatarDocumento(props.row.documentoProdutor) }})

                                    .box-expande-listagem-box
                                        .box-expande-listagem-box-texto
                                            | Análise
                                        .box-expande-listagem-box-value
                                            div(
                                                :class='corSituacao(props.row.situacao)'
                                            )
                                                i(
                                                    :class='getIcone(props.row.situacao)'
                                                )
                                                | {{ legendaSituacao(props.row.situacao) }}

                                    .box-expande-listagem-box
                                        .box-expande-listagem-box-texto
                                            | Volume
                                        .box-expande-listagem-box-value
                                            div {{ props.row.volume }}
                                .box-expande-listagem
                                    .box-expande-listagem-box
                                        .box-expande-listagem-box-texto
                                            | Valor
                                        .box-expande-listagem-box-value
                                            div {{ props.row.valor }}

                                    .box-expande-listagem-box
                                        .box-expande-listagem-box-texto
                                            | Capacidade produtiva
                                        .box-expande-listagem-box-value
                                            div(
                                                v-if='props.row.capacidadeProdutiva != "0t"'
                                            ) {{ props.row.capacidadeProdutiva }}
                                            div(
                                                v-if='props.row.capacidadeProdutiva == "0t"',
                                                style='word-break: break-all'
                                            ) Não existem dados para essa cultura/safra/estado

                                    .box-expande-listagem-box
                                        .box-expande-listagem-box-texto
                                            | Município
                                        .box-expande-listagem-box-value
                                            div {{ buscarMunicipio(props.row.codigoCar) }}

                        el-table-column(prop='codigoCar', label='CAR')

                        el-table-column(label='Restrições', width='130')
                            template(slot-scope='scope')
                                span {{ scope.row.restricoesFormatadas }}

                        el-table-column(
                            label='Ações',
                            width='100',
                            align='center'
                        )
                            template(slot-scope='scope')
                                el-dropdown.action-button(trigger='click')
                                    span.el-dropdown-link
                                        i.mdi.mdi-dots-vertical.mudando-cursor
                                    el-dropdown-menu(slot='dropdown')
                                        el-dropdown-item(
                                            v-for='(acao, index) in acoesImovel',
                                            :key='index',
                                            :icon='acao.icone',
                                            :disabled='buscandoDiagnosticos',
                                            @click.native='acao.callback(scope.row)'
                                        ) {{ acao.nome }}
                        template(slot='empty')
                            el-empty(description='Sem dados')
                    .tabela-rodape
                        .tabela-rodape--esquerda
                            p {{ totalCars }} car(s) em monitoramento

                .col-5.pr-0
                    .mapaMonitoramentoOperacaoCdaWa
                        mapa(
                            :showStatesLayers='false',
                            :mapLayersConfigs='layersMaps',
                            :mapConfig='mapConfig',
                            :height='"100%"',
                            :idMapa='"mapaMonitoramentoOperacaoCdaWa"',
                            ref='mapa',
                            :doubleMapOnPage='false'
                        )
    ModalResultadoDiagnosticoOperacaoCdaWa(
        ref='modalResultadoDiagnosticoRef',
        habilitar-inibicao-camada,
        :carSelecionadoAnalise='carSelecionadoAnalise',
        @atualizarDadosMonitoramento='buscarDados'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import OperacaoCdaWaService from '@/services/OperacaoCdaWaService';
import Mapa from '@/components/MapaLeaflet';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import UtilsService from '@/services/UtilsService';

import ModalResultadoDiagnosticoOperacaoCdaWa from '@/components/operacao-cda-wa/ModalResultadoDiagnosticoOperacaoCdaWa.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

import formatters from '@/utils/formatters';

export default {
    components: {
        BaseHeader,
        ModalResultadoDiagnosticoOperacaoCdaWa,
        Mapa,
        BaseButton
    },
    name: 'MonitoramentoOperacoesCdaWa',
    data() {
        return {
            acoesImovel: [
                {
                    nome: 'Visualizar análise do Imóvel',
                    icone: 'flow flow-environment',
                    callback: this.visualizarAnaliseImovel
                }
            ],

            buscandoOperacao: true,
            buscandoDiagnosticos: true,
            buscandoCars: true,
            operacao: {},
            cars: [],
            geometriasCAR: [],
            carSelecionadoAnalise: '',
            totalCars: 0,
            totalRestricoes: 0,
            pessoas: [],
            classesCoresStatus: {
                Aprovado: 'status_aprovado',
                Reprovado: 'status_reprovado',
                Processado: 'status_processado',
                'Em processamento': 'status_em_processamento'
            },

            dadosAnaliseFornecedor: {},
            dadosAnaliseImovel: {},
            layersMaps: [],
            mapConfig: {
                controls: {
                    popupControl: false,
                    drawControl: false,
                    zoomControl: true,
                    camadasControl: false,
                    fullscreen: false,
                    buscarCarControl: false,
                    bufferControl: false,
                    uploadFileControl: false,
                    camadasBaseControl: false,
                    botaoAnotacoes: false,
                    ferramentasControl: false
                },
                inspecionar: false,
                diagnostico: false
            }
        };
    },
    async mounted() {
        await this.buscarDados();
    },

    methods: {
        async buscarDados() {
            await this.buscarDadosOperacao();
            await this.buscarCarsDaOperacao();
            await this.buscarDiagnosticos();
        },

        async buscarDadosOperacao() {
            this.buscandoOperacao = true;
            this.totalRestricoes = 0;

            try {
                const { data } = await OperacaoCdaWaService.buscarOperacaoPorId(
                    this.$route.params.idOperacao
                );
                const operacao = JSON.parse(data);

                this.operacao = operacao;
                this.pessoas.push({
                    nome: operacao.fornecedorNome,
                    documento: operacao.fornecedorDocumento,
                    papel: 'Fornecedor'
                });

                this.totalRestricoes += operacao.restricoes;
            } catch (e) {
                this.$notify.error(
                    'Não foi possível buscar dados da operação.'
                );
                this.$router.push({ name: 'OperacoesCdaWa' });
            } finally {
                this.buscandoOperacao = false;
            }
        },

        async buscarDiagnosticos() {
            this.buscandoDiagnosticos = true;
            try {
                const { data } =
                    await OperacaoCdaWaService.buscarMonitoramentoOperacaoPorIdOperacao(
                        this.$route.params.idOperacao
                    );

                const { fornecedor, imoveis } = data;

                this.dadosAnaliseFornecedor = {
                    grupo: [
                        {
                            documento: this.formatarDocumento(
                                fornecedor.documento
                            ),
                            territorioProximidade: false,
                            nome: fornecedor.nome,
                            titulo: 'Pessoa Analisada',
                            diagnostico: fornecedor.diagnostico
                        }
                    ]
                };

                let monitoramento = [];

                if (imoveis.length) {
                    imoveis.forEach(imovel => {
                        let produtorGrupo = {
                            documento: this.formatarDocumento(
                                imovel.produtor.documento
                            ),
                            territorioProximidade: false,
                            nome: imovel.produtor.nome,
                            titulo: 'Produtor',
                            diagnostico: imovel.produtor.diagnostico
                        };

                        let imovelGrupo = {
                            documento: null,
                            nome: imovel.nome,
                            titulo: 'Imóvel',
                            diagnostico: []
                        };

                        imovel.diagnosticos.forEach(car => {
                            car.diagnosticos.forEach(diagnostico => {
                                imovelGrupo.diagnostico.push(diagnostico);
                            });

                            monitoramento.push({
                                geometria: car.imovel.geometria,
                                grupo: [imovelGrupo, produtorGrupo]
                            });
                        });
                    });

                    this.dadosAnaliseImovel = monitoramento;
                }
            } catch (e) {
                this.$notify.error(
                    'Não foi possível buscar diagnósticos do monitoramento.'
                );
            } finally {
                this.buscandoDiagnosticos = false;
            }
        },

        async buscarCarsDaOperacao() {
            this.buscandoCars = true;
            const dados = {
                idOperacao: this.$route.params.idOperacao,
                apenasInconformes: false,
                page: 0,
                size: 9999,
                sort: 'situacao,asc'
            };

            try {
                const { data } =
                    await OperacaoCdaWaService.buscarCarsDaOperacao({
                        ...dados
                    });

                if (!data.includes('[]')) {
                    const { itens, totalItens, totalRestricoes } =
                        JSON.parse(data);

                    this.cars = itens;
                    this.totalCars = totalItens;
                    this.totalRestricoes += totalRestricoes;
                    this.adicionarPontosMapaImovel();
                }
            } catch (e) {
                this.$notify.error(
                    'Não foi possível buscar os imóveis da operação.'
                );
            } finally {
                this.buscandoCars = false;
            }
        },

        adicionarPontosMapaImovel() {
            this.layersMaps = [];
            UtilsService.getDadosCAR({
                codigosCar: Array.from(
                    this.cars.map(c => c.codigoCar)
                ).toString()
            }).then(({ data }) => {
                this.geometriasCAR = data.resultados;
                data.resultados.forEach(({ geometry, properties }) => {
                    this.layersMaps.push({
                        style: getEstiloGeometria('area'),
                        name: properties.codigo,
                        geoJson: geometry
                    });
                });
            });
        },

        buscarMunicipio(codigoCar) {
            const { properties } = this.geometriasCAR.filter(
                geo => geo.properties.codigo === codigoCar
            )[0];

            return properties !== null && properties !== 'undefined'
                ? `${properties.nome_municipio}-${properties.uf}`
                : '-';
        },

        highlightImovelEnter(row, expanded) {
            if (expanded.length) {
                this.layersMaps = [];
                this.geometriasCAR
                    .filter(geo => geo.properties.codigo === row.codigoCar)
                    .forEach(({ geometry, properties }) => {
                        this.layersMaps.push({
                            style: getEstiloGeometria('area'),
                            name: properties.codigo,
                            geoJson: geometry
                        });
                    });
            } else {
                this.highlightImovelLeave();
            }
        },

        highlightImovelLeave() {
            this.layersMaps = [];
            this.geometriasCAR.forEach(({ geometry, properties }) => {
                this.layersMaps.push({
                    style: getEstiloGeometria('area'),
                    name: properties.codigo,
                    geoJson: geometry
                });
            });
        },

        formatarDocumento(documento) {
            return formatters.numeralStringFormatToDocumento(documento);
        },

        corSituacao(situacao) {
            if (situacao === 'INCONFORME') {
                return 'vermelho';
            } else if (situacao === 'CONFORME') {
                return 'verde';
            } else {
                return 'amarelo';
            }
        },

        legendaSituacao(situacao) {
            if (situacao === 'INCONFORME') {
                return 'Inconforme';
            } else if (situacao === 'CONFORME') {
                return 'Conforme';
            } else {
                return ' Alerta';
            }
        },

        getIcone(situacao) {
            if (situacao === 'INCONFORME') {
                return 'mdi mdi-alert-circle danger';
            } else if (situacao === 'CONFORME') {
                return 'flow flow-verified';
            } else {
                return 'flow flow-warning-sign';
            }
        },

        getTotalRestricoes(total) {
            if (isNaN(total)) {
                return 'Sem dados';
            }
            return `${formatters.formatNumber(total, 0)} ${
                total === 0 ? 'restrição encontrada' : 'restrições encontradas'
            } no monitoramento`;
        },

        async visualizarAnalisePessoa() {
            this.$refs.modalResultadoDiagnosticoRef.abrirModal({
                ...this.dadosAnaliseFornecedor,
                diagnosticoPessoa: true
            });
        },

        async visualizarAnaliseImovel({ id, codigoCar }) {
            let monitoramentoFiltrado = this.dadosAnaliseImovel.filter(item => {
                // Verificar se o nome desejado está presente no grupo
                return item.grupo.some(grupo => grupo.nome === codigoCar);
            });

            this.carSelecionadoAnalise = codigoCar;
            this.$refs.modalResultadoDiagnosticoRef.abrirModal(
                ...monitoramentoFiltrado
            );
        }
    }
};
</script>
<style lang="scss">
#el-table {
    width: 2000px;
}

#monitoramento-operacoes-cda-wa {
    h2 {
        display: block;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 10px;
    }
    .voltar {
        cursor: pointer;
        margin-right: 10px;
    }

    .titulo_padrao {
        font-weight: 600;
        font-size: 16px;
        width: 100%;
        margin-bottom: 10px;
    }

    .monitoramento-operacao__dados-gerais {
        margin-bottom: 20px;

        .monitoramento-operacao__dados-gerais__body {
            background-color: var(--white);
            width: 100%;
            padding: 24px;
            border-radius: $default-border-radius;
            box-shadow: 0 1px 5px 0 var(--block-shadow);

            .monitoramento-operacao__dados-gerais__body__title {
                font-size: 14px;
                color: var(--primary);
                margin-bottom: 5px;
                font-weight: 600;
            }

            .monitoramento-operacao__dados-gerais__body__value {
                font-size: 14px;
                color: var(--secondary-font-color);
            }
        }
    }

    .monitoramento-operacao__restricoes {
        background-color: #f883421a;
        border-radius: $default-border-radius;
        height: 55px;
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .monitoramento-operacao__restricoes__icone {
            height: 100%;
            width: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px 0 0 4px;
            background-color: var(--warning);
            margin-right: 20px;

            .monitoramento-operacao__restricoes__icone__icone {
                font-size: 24px;
                color: var(--white);
            }
        }

        .monitoramento-operacao__restricoes__texto {
            line-height: 16px;
            font-weight: 600;
            font-size: 14px;
        }
    }

    .monitoramento-operacao__listagem-imoveis {
        margin-bottom: 20px;
    }

    .tabela {
        border-radius: 5px;
        height: 400px;
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .el-table {
            border-radius: 5px;
            height: calc(100% - 54px);
            width: 100%;
        }

        .el-table th {
            color: var(--primary);
            font-weight: normal;
            font-size: 13px;
        }

        .el-table__row.expanded:hover,
        .el-table--enable-row-hover
            .el-table__body
            tr:hover
            > td.el-table__cell,
        .el-table__row.expanded,
        td.el-table__cell.el-table__expanded-cell {
            background-color: var(--background-rgba) !important;
        }

        .expanded
            td.el-table_1_column_1.undefined.el-table__expand-column.el-table__cell,
        .el-table__row.expanded,
        td.el-table__cell.el-table__expanded-cell {
            border-left: 2px solid var(--secondary) !important;
        }

        .tabela-btn {
            margin-top: 14px;
            display: flex;
            justify-content: start;
            align-items: center;
        }

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            border-radius: 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }

        .box-expande-listagem {
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
            margin-top: 15px;
            margin-bottom: 15px;
            padding: 0 18px;

            .box-expande-listagem-box {
                width: 33%;

                .box-expande-listagem-box-texto {
                    font-weight: 600;
                    color: var(--primary);
                }

                .box-expande-listagem-box-value {
                    padding: 0;
                    max-height: 75px;
                    overflow-y: auto;
                    font-weight: 400;
                    color: var(--primary);
                }
            }
        }

        .box-expande-listagem {
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
            margin-top: 15px;
            margin-bottom: 15px;
            padding: 0 18px;

            .box-expande-listagem-box {
                width: 33%;

                .box-expande-listagem-box-texto {
                    font-weight: 600;
                    color: var(--primary);
                }

                .box-expande-listagem-box-value {
                    padding: 0;
                    max-height: 75px;
                    overflow-y: auto;
                    font-weight: 400;
                    color: var(--primary);
                }
            }
        }
    }

    .mapaMonitoramentoOperacaoCdaWa {
        background-color: #7777;
        height: 100%;
        width: 100%;
        border-radius: 5px;
    }

    #mapaMonitoramentoOperacaoCdaWa {
        border-radius: 5px;
    }
}
</style>
